export default __webpack_public_path__ + "static/media/details.f690991c.svg";